import { render } from "./Odometer.vue?vue&type=template&id=1879cac8&scoped=true&ts=true"
import script from "./Odometer.vue?vue&type=script&lang=ts"
export * from "./Odometer.vue?vue&type=script&lang=ts"

import "./Odometer.vue?vue&type=style&index=0&id=1879cac8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1879cac8"]])

export default __exports__